import AddUserPage from './AddUserPage';

export default AddUserPage;
